import { isOrderExpired } from '@cowprotocol/common-utils'
import { EnrichedOrder } from '@cowprotocol/cow-sdk'

import { OrderStatus } from 'legacy/state/orders/actions'
import { isOrderFulfilled, isTwapOrderCancelled } from 'legacy/state/orders/utils'

import { TwapOrderItem, TwapOrderStatus } from '../types'

/**
 * Derives the display status of a TWAP part from its order state and parent status.
 *
 * Parent completion and cancellation take precedence over the part state. A virtual
 * part is scheduled only when no terminal status applies.
 */
// eslint-disable-next-line complexity
export function getPartOrderStatus(
  enrichedOrder: Omit<EnrichedOrder, 'settlementContract'>,
  parent: TwapOrderItem,
  isVirtualPart: boolean,
): OrderStatus {
  const isExpired = isOrderExpired(enrichedOrder, 0)
  const isCancelled = isTwapOrderCancelled(enrichedOrder)

  // If parent is fulfilled, all parts are fulfilled
  if (parent.status === TwapOrderStatus.Fulfilled) return OrderStatus.FULFILLED

  if (isOrderFulfilled(enrichedOrder)) return OrderStatus.FULFILLED

  if (parent.status === TwapOrderStatus.Cancelled) {
    if (isExpired && !isCancelled) {
      return OrderStatus.EXPIRED
    }

    return OrderStatus.CANCELLED
  }
  if (isCancelled) return OrderStatus.CANCELLED

  const hasParentExecutionFinished =
    parent.status === TwapOrderStatus.Expired || parent.status === TwapOrderStatus.PartiallyFilled
  if (hasParentExecutionFinished) return OrderStatus.EXPIRED
  if (isExpired) return OrderStatus.EXPIRED

  if (isVirtualPart) return OrderStatus.SCHEDULED

  return OrderStatus.PENDING
}
